@import 'styles/mixins';
@import 'styles/variables';

.heading {
  @include ui-sm-text;
  color: $gray-70;
  margin-bottom: 11px;
}
